import { componentResolverFromMap } from "gatsby-plugin-prismic-previews";

import { linkResolver } from "./link-resolver";

import TeamPageTemplate from "../../src/pages/{prismicTeamPage.uid}";
import CityPageTemplate from "../../src/pages/{prismicCityPage.uid}";
import TestimonialsPageTemplate from "../../src/pages/{prismicTestimonialsPage.uid}";
import WhyNowPageTemplate from "../../src/pages/{prismicWhyNowPage.uid}";
import SimplePageTemplate from "../../src/pages/{prismicSimplePage.uid}";
import IndexPageTemplate from "../../src/pages/index";

/**
 * Prismic preview configuration for each repository in your app. This set of
 * configuration objects will be used with the `PrismicPreviewProvider`
 * higher order component.
 *
 * If your app needs to support multiple Prismic repositories, add each of
 * their own configuration objects here as additional elements.
 *
 */
export const repositoryConfigs = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
    linkResolver,
    componentResolver: componentResolverFromMap({
      team_page: TeamPageTemplate,
      city_page: CityPageTemplate,
      testimonials_page: TestimonialsPageTemplate,
      why_now_page: WhyNowPageTemplate,
      simple_page: SimplePageTemplate,
      home_page: IndexPageTemplate,
      // Add more mappings as needed for other templates
    }),
  },
];